import produce from 'immer';

import {
  GET_SCHEDULE_OTP_CODE_FAILURE,
  GET_SCHEDULE_OTP_CODE_START,
  GET_SCHEDULE_OTP_CODE_SUCCESS
} from '@redux/actions/bookingExperience/getScheduleOtpCode/types';

const initialState = {
  isLoading: false,
  getScheduleOtpCodeResult: null,
  error: null
};

const getScheduleOtpCodeReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
    case GET_SCHEDULE_OTP_CODE_START:
      draft.isLoading = true;

      draft.error = null;
      break;

    case GET_SCHEDULE_OTP_CODE_SUCCESS:
      draft.isLoading = false;

      draft.getScheduleOtpCodeResult = action.payload;
      break;

    case GET_SCHEDULE_OTP_CODE_FAILURE:
      draft.isLoading = false;

      draft.error = action.payload;
      break;
    }

    return draft;
  });

export default getScheduleOtpCodeReducer;
